// frontend/src/samkalp-admin/panels/UsersPanel.js
//
// Composes the existing, unmodified Studio TenantUserManagement +
// BulkFacultyManager components for centre-scoped user/faculty management.
import React, { useState, useCallback, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import TenantUserManagement from '../../components/TenantAdmin/TenantUserManagement';
import BulkFacultyManager from '../../components/TenantAdmin/BulkFacultyManager';
import api, { getTenantProjects } from '../../api/api';

const UsersPanel = ({ slug }) => {
    const [faculty, setFaculty] = useState([]);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const [facultyRes, projectsRes] = await Promise.all([
                api.get(`/tenant/${slug}/admin/faculty-roster`),
                getTenantProjects(slug),
            ]);
            setFaculty(facultyRes.data || []);
            setProjects(projectsRes.data || []);
        } catch { /* empty */ }
        setLoading(false);
    }, [slug]);

    useEffect(() => { load(); }, [load]);

    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;

    return (
        <>
            <div className="mb-4">
                <TenantUserManagement tenantSlug={slug} onChanged={load} />
            </div>
            <div>
                <BulkFacultyManager slug={slug} allFaculty={faculty} allProjects={projects} onComplete={load} />
            </div>
        </>
    );
};

export default UsersPanel;
